// extracted by mini-css-extract-plugin
export default {"wrapper":"EditHotel_wrapper__Bxvdv","formError":"EditHotel_formError__Mywj9"};